import { queryClient } from '@api/queryClient';
import { LookupQueries, LOOKUP_QUERY_KEYS } from '@api/services/lookup';

export const prefetchCreditUnitsByDistrict = (district?: string) => {
  if (!district) return;

  return queryClient.prefetchQuery({
    queryKey: [LOOKUP_QUERY_KEYS.GET_CREDIT_UNITS_BY_DISTRICT, district],
    queryFn: () => LookupQueries.getCreditUnitsForDistrict(district),
  });
};

export const prefetchNwpGpPermitTypes = () => {
  return queryClient.prefetchQuery({
    queryKey: [LOOKUP_QUERY_KEYS.GET_NWP_GP_PERMIT_TYPES],
    queryFn: () => LookupQueries.getNwpGpPermitTypes(),
  });
};
